let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iB2zz"), load("kpzlp")]).then(() => parcelRequire('i34K4'));